import type { AnnouncementDisplayType } from './types';

const DISMISS_PREFIX = 'announcement_dismissed_';

/**
 * Build the UserPreferences key used to persist an announcement's dismiss state.
 */
export function buildDismissPreferenceKey(
  announcementId: string,
  displayType?: AnnouncementDisplayType
): string {
  return displayType
    ? `${DISMISS_PREFIX}${displayType}_${announcementId}`
    : `${DISMISS_PREFIX}${announcementId}`;
}
